// components/Timesheet/TimesheetEntryForm.tsx
import React, { useState } from "react";
import { useTimesheet } from "../../contexts/TimesheetContext";
// import { useAuth } from "../../contexts/AuthContext";
import {
  Box,
  TextField,
  Button,
  Paper,
  Typography,
  Grid,
  Alert,
} from "@mui/material";

export const TimesheetEntryForm: React.FC = () => {
  // const { user } = useAuth();
  const {
    currentTimesheet,
    createTimesheet,
    updateEntry,
    calculateHours,
    getCurrentWeek,
  } = useTimesheet();
  const [date, setDate] = useState("");
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [breakMinutes, setBreakMinutes] = useState(30);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (!date || !startTime || !endTime) {
      setError("Please fill in all required fields");
      return;
    }

    try {
      // const totalHours = calculateHours(startTime, endTime, breakMinutes);

      const entryInput = {
        date,
        startTime,
        endTime,
        breakMinutes,
      };

      if (currentTimesheet?.id && !currentTimesheet.id.startsWith("local-")) {
        // Update existing timesheet
        // You might need to implement an "add entry" mutation
        await updateEntry(
          currentTimesheet.id,
          `entry-${Date.now()}`,
          entryInput
        );
      } else {
        // Create new timesheet with this entry
        const { weekStart, weekEnd } = getCurrentWeek();
        const input = {
          weekStart,
          weekEnd,
          entries: [entryInput],
        };
        await createTimesheet(input);
      }

      setSuccess("Time entry added successfully!");
      // Reset form
      setDate("");
      setStartTime("");
      setEndTime("");
      setBreakMinutes(30);
    } catch (err) {
      setError("Failed to add time entry. Please try again.");
      console.error("Error adding time entry:", err);
    }
  };

  const calculatedHours =
    startTime && endTime ? calculateHours(startTime, endTime, breakMinutes) : 0;

  return (
    <Paper sx={{ p: 3 }}>
      <Typography variant="h6" gutterBottom>
        Add Time Entry
      </Typography>

      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}
      {success && (
        <Alert severity="success" sx={{ mb: 2 }}>
          {success}
        </Alert>
      )}

      <form onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="Date"
              type="date"
              value={date}
              onChange={(e) => setDate(e.target.value)}
              InputLabelProps={{ shrink: true }}
              required
            />
          </Grid>

          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="Start Time"
              type="time"
              value={startTime}
              onChange={(e) => setStartTime(e.target.value)}
              InputLabelProps={{ shrink: true }}
              required
            />
          </Grid>

          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="End Time"
              type="time"
              value={endTime}
              onChange={(e) => setEndTime(e.target.value)}
              InputLabelProps={{ shrink: true }}
              required
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Break Minutes"
              type="number"
              value={breakMinutes}
              onChange={(e) => setBreakMinutes(Number(e.target.value))}
              inputProps={{ min: 0, max: 240 }}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <Box sx={{ display: "flex", alignItems: "center", height: "100%" }}>
              <Typography variant="body1">
                Total Hours: <strong>{calculatedHours.toFixed(2)}</strong>
              </Typography>
            </Box>
          </Grid>
        </Grid>

        <Box sx={{ mt: 2 }}>
          <Button type="submit" variant="contained" color="primary">
            Add Entry
          </Button>
        </Box>
      </form>
    </Paper>
  );
};
